import meiliSearchApiClient from 'src/api/clients/meilisearch';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { MeiliSearchResponse } from 'src/types/responses/meilisearch';
import { Issue } from '../types/response/issue.response';
import { calculatePaginationOffset } from 'src/utils/calculate-pagination-offset';
import { EditIssueStatus } from '../types/payload/edit-issue-status';
import tenantApi from 'src/api/clients/tenant';

export const fetchIssues = async (
  tenantToken: string,
  searchState: SearchState,
  page: number,
  perPage: number,
) => {
  const { data } = await meiliSearchApiClient.post<MeiliSearchResponse<Issue>>(
    `/indexes/Issue-${tenantToken}/search`,
    {
      ...searchState,
      limit: perPage,
      offset: calculatePaginationOffset(page, perPage),
    },
  );

  return data;
};

export const editIssueStatus = async ({
  token,
  newStatus,
  comment,
}: EditIssueStatus): Promise<void> => {
  await tenantApi.put<void>(`/issues/${token}/status`, {
    newStatus,
    comment,
  });
};
